<template>
  <nav class="navbar is-fixed-bottom">
    <div class="tabs is-fullwidth is-toggle is-borderless is-elevated">
      <ul>
        <li >
          <a to="#" @click.prevent="toggleDrawer" title="Меню">
            <span class="icon" >
              <i :class="`fas fa-lg fa-${showDrawer ? 'times' : 'bars'}`"></i>
            </span>
          </a>
        </li>
        <li v-for="(link, index) in links" :key="index">
          <router-link :to="link.href" :class="'column has-text-centered  '" :title="link.title" exact >
            <span class="icon" >
              <i :class="`fas fa-lg fa-${link.icon}`"></i>
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/me" class="column has-text-centered " title="Профиль" exact>
            <span class="icon" >
              <i class="fas fa-lg fa-user"></i>
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  props: {
    showDrawer: Boolean,
    links: {
      href: '',
      title: '',
      icon: ''
    }
  },
  methods: {
    toggleDrawer () {
      this.$emit('update:show-drawer', !this.showDrawer)
    }
  }
}
</script>
<style lang="scss" >
  .is-borderless a {
    border: none!important;
  }
  .tabs .is-active {
    box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.1);
  }
</style>
